module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-six-members/key-amk/key-2.svg?v=84f0222a";